import React from 'react';
import StatusCards from '../components/StatusCards';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { FormControl, FormLabel, TextField } from '@mui/material';
import { Input } from '@mui/material';
import './Home.css';
import { Navigate } from 'react-router-dom';

function Home() {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [errorMsg, setErrorMsg] = useState(null);

  async function loginUser(credentials) {

    return fetch('/api/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(credentials)
    })
      .then(data => {
        console.log(data);
        // check the status code
        if (data.status === 401) {
          setErrorMsg("Usuario o contraseña incorrectos");
          return null;
        }
        if (data.status === 500) {
          setErrorMsg("Error de servidor");
          return null;
        }
        if (data.status === 404) {
          setErrorMsg("Error de conexión, servidor no encontrado");
          return null;
        }
        return data.json();
      })
      .catch(error => console.error(error))
  }

  function setToken(userToken) {
    sessionStorage.setItem('token', JSON.stringify(userToken));
  }

  // check if token exists
  function getToken() {
    const tokenString = sessionStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    return userToken?.token
  }

  const token = getToken();

  const [showVideo, setShowVideo] = React.useState(true);
  const [showButton, setShowButton] = React.useState(false);
  const video = require('../components/Madrid_City_Council.mp4');
  const navigate = useNavigate();

  const handleStart = async () => {
    var token = getToken();

    if (token) {

      navigate('/profile', { replace: true });
      // force reload
      window.location.reload();
    } else {
      token = await loginUser({
        email: username,
        password: password,
      });

      console.log(token);

      if (token) {
        setToken(token);

        // navigate to profile
        navigate('/profile');
        window.location.reload();

      }
    }
  };

  const showLoginForm = () => {
    return (
      <div className='form'>
        <div className='form-control'>
          <span>Email</span>
          <Input
          id='email'
            placeholder="@madrid.es"
            onChange={(e) => setUserName(e.target.value)}
          />
        </div>
        <div className='form-control'>
          <span>Password</span>
          <Input
          id='password'
            type="password"
            placeholder="****"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      {showVideo && (
        <video src={video} width="900" height="500" controls={false} autoPlay muted onEnded={() => {
          setShowVideo(false)
          setShowButton(true)
        }
        } />
      )}
      {showButton && (
        <div className='login-wrapper'>
          <FormControl width="300px">
            {!token && showLoginForm()}

            <Button className='startButton' onClick={() => handleStart()}>Entrar</Button>
          </FormControl>

          {errorMsg && (<div className='error'>{errorMsg}</div>)}
        </div>

      )
      }
    </div>
  );
}

export default Home;
